import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drawer relative overflow-x-hidden" }
const _hoisted_2 = { class: "drawer-content flex flex-col min-h-screen" }
const _hoisted_3 = { class: "container mx-auto px-1 sm:px-6 flex flex-col justify-center items-center" }
const _hoisted_4 = { class: "drawer-side" }

import { ModalsContainer } from "vue-final-modal";
import NavBar from "@/components/NavBar.vue";
import PageFooter from "@/components/PageFooter.vue";
import ConfigInfo from "@/components/config/ConfigInfo.vue";
import MainAreaSwitcher from "@/components/main/MainAreaSwitcher.vue";
import SettingsDialog from "@/components/settings/SettingsDialog.vue";
import CookiesPopup from "@/components/CookiesPopup.vue";
import HelpGuide from "@/components/HelpGuide.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("input", {
        id: "side-drawer",
        type: "checkbox",
        class: "drawer-toggle"
      }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(NavBar),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ConfigInfo, { class: "tour-config-info my-4" }),
          _createVNode(MainAreaSwitcher)
        ]),
        _createVNode(HelpGuide),
        _createVNode(PageFooter, { class: "mt-auto" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("label", {
          for: "side-drawer",
          class: "drawer-overlay"
        }, null, -1)),
        _createVNode(SettingsDialog, { class: "max-w-md min-h-full p-8 py-4" })
      ])
    ]),
    _createVNode(CookiesPopup),
    _createVNode(_unref(ModalsContainer))
  ], 64))
}
}

})